import * as tslib_1 from "tslib";
import { getValueByKey } from '@awp/core/utils';
import { Subject } from 'rxjs';
var ContentParser = /** @class */ (function () {
    function ContentParser() {
        this.contextKey = 'context';
    }
    return ContentParser;
}());
export { ContentParser };
var ContentDefaultParser = /** @class */ (function (_super) {
    tslib_1.__extends(ContentDefaultParser, _super);
    function ContentDefaultParser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
        _this._contextChanged = new Subject();
        _this.contextChanged = _this._contextChanged.asObservable();
        return _this;
    }
    Object.defineProperty(ContentDefaultParser.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (value) {
            this._context = value;
            this._contextChanged.next();
        },
        enumerable: true,
        configurable: true
    });
    ContentDefaultParser.prototype.interpolate = function (expr, params) {
        var result;
        if (typeof expr === 'string') {
            result = this.interpolateString(expr, params);
        }
        else if (typeof expr === 'function') {
            result = this.interpolateFunction(expr, params);
        }
        else {
            // this should not happen, but an unrelated TranslateService test depends on it
            result = expr;
        }
        // Fix issue with Umbraco encoding for href
        if (result != null) {
            result = result.replace(/href="\/http/g, 'href="http');
        }
        return result;
    };
    ContentDefaultParser.prototype.getValue = function (target, key) {
        if (key.startsWith(this.contextKey + ".")) {
            target = this.context;
            key = key.substr((this.contextKey + ".").length);
        }
        target = getValueByKey(target, key);
        return target;
    };
    ContentDefaultParser.prototype.interpolateFunction = function (fn, params) {
        return fn(params);
    };
    ContentDefaultParser.prototype.interpolateString = function (expr, params) {
        var _this = this;
        if ((params == null && this.context == null) || !expr.includes('{{')) {
            return expr;
        }
        var result = expr.replace(this.templateMatcher, function (substring, token) {
            var value = _this.getValue(params, token) || '';
            // If the value contains {{ value }} then this needs to be interpolated as well.
            while (typeof value === 'string' && value.includes('{{')) {
                value = _this.interpolateString(value, params);
            }
            return value;
        });
        return result;
    };
    return ContentDefaultParser;
}(ContentParser));
export { ContentDefaultParser };
